import { defineComponent, createElementBlock, openBlock, renderSlot } from "vue";
const _hoisted_1 = { class: "app-content-details" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppContentDetails",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcAppContentDetails.vue_vue_type_script_setup_true_lang-Dnf4r_Ng.mjs.map
